// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"intro-module--wrapper--3TuFQ","hero":"intro-module--hero--2qz3r","social":"intro-module--social---morE"};